const getApiLocation = () => {
  return process.env.VUE_APP_API_URL || 'http://localhost:5000/api'
}

export default getApiLocation
